/* src/app/shared/confirmation-dialog/confirmation-dialog.component.css */
.main {
  min-height: 100%;
}
/*# sourceMappingURL=confirmation-dialog.component.css.map */
